/**
 * IPC modal-visibility Redux slice.
 *
 * Reflects Tauri IPC events as boolean flags that control overlay rendering:
 * - `exitApp`          — app-exit confirmation dialog.
 * - `confirmDownload`  — auto-update download confirmation dialog.
 * - `downloadProgress` — update download progress bar.
 */
import { createSlice } from "@reduxjs/toolkit";

/** Shape of the IPC modal state tree. */
export interface IPCEventsModalState {
  exitApp: boolean;
  confirmDownload: boolean;
  downloadProgress: boolean;
}

const initialIPCEventsModalState: IPCEventsModalState = {
  exitApp: false,
  confirmDownload: false,
  downloadProgress: false,
};

export const ipcEventsModalSlice = createSlice({
  name: "ipcEventsModalState",
  initialState: initialIPCEventsModalState,
  reducers: {
    exitAppReducer: (state, action) => {
      state.exitApp = action.payload.exitApp;
    },
    confirmDownloadReducer: (state, action) => {
      state.confirmDownload = action.payload.confirmDownload;
    },
    downloadProgressReducer: (state, action) => {
      state.downloadProgress = action.payload.downloadProgress;
    },
  },
});

export const {
  exitAppReducer,
  confirmDownloadReducer,
  downloadProgressReducer,
} = ipcEventsModalSlice.actions;
export default ipcEventsModalSlice.reducer;
